<template>
  <div class="body-wrapper">
    <div class="editable">
      <div class="single-info">
        <div class="label">Tekući račun</div>
        <div class="value">
          <span class="account">{{ accountDetails.account }}</span>
        </div>
      </div>
      <div class="single-info">
        <div class="label">Matični broj</div>
        <div class="value">
          <span>{{ accountDetails.mb ? accountDetails.mb : '/' }}</span>
        </div>
      </div>
      <div class="single-info">
        <div class="label">PIB</div>
        <div class="value">
          <span>{{ accountDetails.pib ? accountDetails.pib : '/' }}</span>
        </div>
      </div>
      <div class="single-info action">
        <div class="edit-btn">
          <a
            class="btn btn-primary edit-btn"
            @click="showModal('ModalContentEditCommunityAccount')"
            >Izmeni podatke</a
          >
        </div>
      </div>
    </div>
    <div>
      <tabs
        :options="{ useUrlFragment: false }"
        cache-lifetime="0"
        @changed="setTable"
      >
        <tab name="Stanovi" id="stanovi">
          <div class="table-wrapper">
            <div class="top-left-wrapper apartments">
              <button
                class="btn btn-primary btn-new-apartment"
                @click="showModal('ModalContentAddProperty')"
              >
                Novi stan
              </button>
              <p class="numMembers" v-if="!loading">
                <b>Broj stanova: {{ tableData.length }}</b>
              </p>
            </div>
            <spinner
              class="spinner"
              line-fg-color="#00796b"
              :size="100"
              :line-size="6"
              v-if="loading"
            ></spinner>
            <div v-if="!loading">
              <data-table
                :columns="table.tableColumns"
                :tableData="tableData"
                :options="table.tableOptions"
                :slotNameActionCommunityProperties="'action'"
                @row-click="openPropertyDetails"
              ></data-table>
            </div>
          </div>
        </tab>

        <tab
          name="Korisnici na čekanju"
          :suffix="getNumberOfPendings"
          id="clanoviNaCekanju"
        >
          <div class="table-wrapper">
            <div class="top-left-wrapper members">
              <p class="numMembers" v-if="!loading">
                <b>Broj korisnika na čekanju: {{ tableData.length }}</b>
              </p>
            </div>
            <spinner
              class="spinner"
              line-fg-color="#00796b"
              :size="100"
              :line-size="6"
              v-if="loading"
            ></spinner>
            <div v-if="!loading">
              <data-table
                :columns="tableColumns"
                :tableData="tableData"
                :options="tableOptions"
                :slotNamePending="'pending'"
              ></data-table>
            </div>
          </div>
        </tab>
        <tab name="Pozovi nove korisnike">
          <div class="invite-members">
            <div class="input-wrapper" v-for="(mail, i) of emails" :key="i">
              <input
                type="email"
                placeholder="Unesite email"
                class="form-control form-control-lg email-input"
                v-model="mail.address"
              />
              <i
                class="far fa-minus-square icon"
                v-if="emails.length > 1"
                @click="removeMail(i)"
              ></i>
            </div>
          </div>
          <div class="plus-wrapper">
            <i class="far fa-plus-square icon" @click="addMail"></i>
          </div>
          <div class="send-invite-btn">
            <button
              :disabled="isDisabled || sending"
              class="btn btn-primary btn--send"
              @click="sendInvites"
            >
              <div v-if="!sending">Pošalji pozivnice na unete adrese</div>
              <spinner :size="20" line-fg-color="#00796b" v-if="sending" />
            </button>
          </div>

          <transition enter-active-class="animated shake">
            <p class="error" v-if="errorMessage.length > 0">
              {{ errorMessage }}
            </p>
          </transition>
        </tab>
        <tab name="Dokumenta" id="dokumenta">
          <div class="table-wrapper">
            <spinner
              class="spinner"
              line-fg-color="#00796b"
              :size="100"
              :line-size="6"
              v-if="loading"
            ></spinner>
            <div v-if="!loading">
              <div class="top-left-wrapper">
                <button
                  @click="showModal('ModalContentAddDocument')"
                  class="btn btn-primary"
                >
                  Dodaj dokument
                </button>
              </div>
              <data-table
                :columns="documentsTable.tableColumns"
                :tableData="tableData"
                :options="documentsTable.tableOptions"
                :slotNameActionCommunityDocuments="'action'"
              ></data-table>
            </div>
          </div>
        </tab>
        <tab name="Detalji zajednice">
          <div class="edit-community">
            <p class="map-desc" :class="{ 'hide-desc': !isEditCommunity }">
              *Pomeranjem pina na mapi možete promeniti lokaciju zajednice
            </p>
            <div class="details-wrapper">
              <div class="table-wrapper community-details">
                <div
                  class="community-image"
                  @click="uploadCommunityPicture"
                  :class="{ 'image-wrapper-edit': isEditCommunity }"
                >
                  <input
                    type="file"
                    accept="image/gif, image/jpeg, image/png"
                    ref="input"
                    hidden
                    @change="setPicture"
                  />
                  <img :src="url" alt="" />
                  <div class="image-edit">
                    <i class="fas fa-pen"></i>
                  </div>
                </div>

                <div class="col-form-label col-form-label-lg lb--mod">
                  Opis zajednice
                </div>
                <textarea
                  type="text"
                  rows="3"
                  class="form-control community-desc"
                  v-model="community.community_desc"
                  placeholder="Unesite opis zajednice..."
                  :disabled="!isEditCommunity"
                />
                <button
                  class="btn btn-primary edit-btn"
                  v-if="!isEditCommunity"
                  @click="enableCommunityEdit"
                >
                  Izmeni podatke
                </button>
                <div class="buttons edit-btn" v-if="isEditCommunity">
                  <button
                    type="submit"
                    class="btn btn-danger btn--mod"
                    @click="closeEdit"
                    :disabled="loading"
                  >
                    Otkaži
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary btn--mod"
                    :disabled="loading"
                    @click="editCommunity"
                  >
                    <p v-if="!loading">Sačuvaj</p>
                    <spinner
                      :size="20"
                      line-fg-color="#00796b"
                      v-if="loading"
                    />
                  </button>
                </div>
              </div>
              <div class="community-map">
                <gmap-map
                  :center="mapCenter"
                  :zoom="16"
                  map-type-id="roadmap"
                  style="width: 100%; height: calc(100% - 50px);"
                >
                  <gmap-marker
                    :position="mapCenter"
                    :draggable="isEditCommunity"
                    :icon="{ url: require('../assets/marker.png') }"
                    @drag="updateCoordinates"
                  />
                </gmap-map>
              </div>
            </div>
          </div>
        </tab>
      </tabs>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/community/Table';
import { Tabs, Tab } from 'vue-tabs-component';
import axios from '@/axios/axios.js';
import '@/assets/css/tabs-component.css';
import { mapState, mapActions, mapMutations } from 'vuex';
import { utilService } from '@/util/UtilService.js';

/*
 * view specialized for members of active community.
 * it has two parts (tabs) : active and pending members.
 * */
export default {
  components: {
    Tabs,
    Tab,
    DataTable
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_OBJECT_STORAGE_URL,
      url: '',
      file: null,
      community: null,
      isEditCommunity: false,
      table: {
        tableColumns: [
          'contact_full_name',
          'description',
          'floor',
          'area_size',
          'num_of_members',
          'note',
          'action'
        ],
        tableOptions: {
          filterable: true,
          headings: {
            contact_full_name: 'Vlasnik stana',
            description: 'Broj stana',
            note: 'Napomena',
            area_size: 'Površina (m²)',
            floor: 'Sprat',
            num_of_members: 'Broj članova',
            action: ''
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje stanovi'
          },
          sortable: ['contact_full_name', 'area_size']
        }
      },
      documentsTable: {
        tableColumns: ['file_name', 'action'],
        tableOptions: {
          filterable: true,
          headings: {
            file_name: 'Naziv',
            action: ''
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje dokumenta'
          },
          sortable: ['file_name']
        }
      },
      newLocation: null,
      mapCenter: {
        lat: 44.80225560855148,
        lng: 20.446508858257303
      },
      communityDocuments: [],
      communityProperties: [],
      updateInterval: null,
      pendingMembersTabActive: false,
      emails: [{ address: '' }],
      sending: false,
      errorMessage: ''
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('table', [
      'tableColumns',
      'tableData',
      'tableOptions',
      'numberOfPendingMembersForCommunity'
    ]),
    ...mapState('finances', ['accountDetails']),
    isDisabled() {
      for (let mail of this.emails) {
        if (mail.address !== '') {
          return false;
        }
      }
      return true;
    },
    getNumberOfPendings() {
      if (this.numberOfPendingMembersForCommunity) {
        if (this.numberOfPendingMembersForCommunity !== 0) {
          return (
            '<span class="badge">' +
            this.numberOfPendingMembersForCommunity +
            '</span>'
          );
        }
      }

      return '';
    }
  },
  async created() {
    this.community = this.$store.getters.getActiveCommunity;
    this.mapCenter = {
      lat: Number(this.community.latitude),
      lng: Number(this.community.longitude)
    };
    this.url = this.baseUrl + this.community.media.link;
    /*
     * setting badge of active view (polls)
     * */
    this.setTableBadge('fa fa-users');

    // this.getActiveMembersByCommunity(this.$route.params.id);

    /*
     * alerts Community view that card is opened so
     * proper badge is loaded*/
    this.cardOpened();
    //setting up table options and table column names
    // this.initTable('memberTable');
    //loading data to table
    this.adjustBadgeNumber(this.$route.params.id);
    // await this.getAllMembersForCommunityFinances(
    //   this.$store.getters.getActiveCommunity.id
    // );
    this.getAccountDetails();
    this.getProperties();
  },
  destroyed() {
    //unsetting table badge
    this.setTableBadge('');
  },
  methods: {
    ...mapMutations('table', ['setTableData']),
    ...mapActions('table', [
      'initTable',
      'getActiveMembersByCommunity',
      'getNotificationNumber',
      'getPendingMembersByCommunity',
      'getAllMembersForCommunityFinances',
      'getDocumentForCommunity'
    ]),
    ...mapMutations('modal', ['showModal', 'setAllProperties']),
    ...mapMutations('table', [
      'setTableBadge',
      'resetNumberOfNotifications',
      'changeNumberOfNotifications'
    ]),
    ...mapMutations([
      'cardOpened',
      'loadingStarted',
      'loadingFinished',
      'setCommunities'
    ]),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapActions('finances', ['getAccountDetails']),

    /*
     *
     * this view has 2 tables (members and pending members)
     * so we need to adjust every table
     * for proper view. Adjusting is triggered by
     * tab click
     *
     * */
    async setTable(changedTab) {
      switch (changedTab.tab.id) {
        case 'stanovi':
          this.pendingMembersTabActive = false;
          this.initTable('memberTable');
          this.getProperties();
          // await this.getAllMembersForCommunityFinances(
          //   this.$store.getters.getActiveCommunity.id
          // );
          break;
        case 'clanoviNaCekanju':
          this.pendingMembersTabActive = true;
          this.initTable('memberPendingTable');
          this.getPendingMembersByCommunity(this.$route.params.id);
          break;
        case 'dokumenta':
          this.pendingMembersTabActive = false;
          this.getDocuments();
          break;
      }
    },
    enableCommunityEdit() {
      this.isEditCommunity = true;
      this.newLocation = {
        lat: Number(this.community.latitude),
        lng: Number(this.community.longitude)
      };
    },
    updateCoordinates(coordinates) {
      this.newLocation = {
        lat: coordinates.latLng.lat(),
        lng: coordinates.latLng.lng()
      };
    },
    openPropertyDetails(data) {
      this.$router.push({
        name: 'propertyDetails',
        params: {
          propertyId: data.row.id
        }
      });
    },
    async getDocuments() {
      try {
        this.loadingStarted();
        const response = await axios.get(
          `/community/${
            this.$store.getters.getActiveCommunity.id
          }/community-document`
        );
        const communityDocuments = response.data.data;
        this.setTableData(communityDocuments);
        this.loadingFinished();
      } catch (error) {
        console.log(error);
        this.setTableData([]);
        this.loadingFinished();
      }
    },
    async getProperties() {
      try {
        this.loadingStarted();
        const res = await axios.get(
          `community/${this.$store.getters.getActiveCommunity.id}/properties`
        );
        let tableData = res.data.data;
        // for (let member of tableData) {
        //   member.dataType = 'virtualMember';
        // }
        // context.commit('setTableCount', res.data.count);
        this.communityProperties = tableData;
        this.loadingFinished();
        this.setAllProperties(this.communityProperties);
        this.setTableData(this.communityProperties);
      } catch (error) {
        console.log(error);
        this.setTableData([]);
        this.loadingFinished();
      }
    },
    addMail() {
      this.emails.push({ address: '' });
    },
    sendInvites() {
      if (this.sending) {
        return;
      }
      this.errorMessage = '';
      for (let mail of this.emails) {
        if (!utilService.isEmailValid(mail.address)) {
          this.errorMessage = 'Morate uneti validne e-mail adrese.';
          return;
        }
      }
      this.sending = true;
      this.removeEmptyMails();
      let validMails = [];

      for (let mail of this.emails) {
        validMails.push(mail.address);
      }

      axios
        .post('mail-invite/send-to-all', {
          community_id: this.$store.getters.getActiveCommunity.id,
          mail_list: validMails
        })
        .then(res => {
          this.emails = [
            {
              address: ''
            }
          ];
          this.showSuccessModal();
        })
        .catch(err => {
          console.log(err);
          this.showFailModal();
        })
        .finally(() => {
          this.sending = false;
        });
    },
    removeEmptyMails() {
      for (let i = 0; i < this.emails.length; i++) {
        if (this.emails[i].address === '') {
          this.emails.splice(i, 1);
        }
      }
    },
    adjustBadgeNumber(communityId) {
      axios
        .post('community/get-pending-members', {
          community_id: communityId
        })
        .then(({ data }) => {
          this.changeNumberOfNotifications(data.member.length);
        })
        .catch(err => {
          console.log(err);
        });
    },
    changeActiveTab(selectedTab) {
      if (selectedTab.tab.name === 'Korisnici na čekanju') {
        this.pendingMembersTabActive = true;
      } else {
        this.pendingMembersTabActive = false;
      }
    },
    removeMail(index) {
      this.emails.splice(index, 1);
    },
    async editCommunity() {
      try {
        this.loadingStarted();
        let mediaId = null;
        if (this.file != null) {
          const mediaData = await axios.post(
            '/media/add',
            this.formatMediaForSubmit(),
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          );
          mediaId = mediaData.data.ids[0];
        }
        const data = {
          address: this.community.address,
          address_id: this.community.address_id,
          city: this.community.city,
          community_id: this.community.community_id,
          community_pic_id: mediaId == null ? this.community.media.id : mediaId,
          description: this.community.community_desc,
          latitude: this.newLocation.lat,
          longitude: this.newLocation.lng,
          municipality_id: this.community.municipality_id,
          street_number: this.community.street_number,
          type: this.community.community_type
        };
        await axios.post('/community/edit', data);
        // refresh community in state
        await this.refreshCommunityList();
        this.isEditCommunity = false;
        this.loadingFinished();
        this.showSuccessModal();
      } catch (error) {
        this.loadingFinished();
        console.log(error);
        this.showFailModal();
      }
    },
    async refreshCommunityList() {
      try {
        const res = await axios.get('user/get-communities');
        let communitiesOfManager = [];
        if (res.data) {
          communitiesOfManager = res.data.filter(c => c.is_manager === '1');
        }
        for (let c of communitiesOfManager) {
          c.notifications = {
            polls: 0,
            tickets: 0,
            members: 0,
            unreadNotificationsCount: 0
          };
        }
        this.setCommunities(communitiesOfManager);
        let data = JSON.parse(localStorage.getItem('k-d'));
        data.communities = communitiesOfManager;
        localStorage.setItem('k-d', JSON.stringify(data));
      } catch (error) {
        throw error;
      }
    },
    uploadCommunityPicture() {
      if (this.isEditCommunity) {
        this.$refs.input.click();
      }
    },
    setPicture(event) {
      this.url = URL.createObjectURL(event.target.files[0]);
      this.file = event.target.files[0];
    },
    formatMediaForSubmit() {
      let fd = new FormData();
      if (this.file != null) fd.append('files[]', this.file, this.file.name);

      fd.append('type', 'user');
      fd.append('community_id', '');
      return fd;
    },
    closeEdit() {
      this.file = null;
      this.url = this.baseUrl + this.community.media.link;
      this.isEditCommunity = false;
      this.mapCenter = {
        lat: Number(this.community.latitude),
        lng: Number(this.community.longitude)
      };
    }
  }
};
</script>
<style scoped lang="scss">
.community-desc {
  resize: none;
}
.send-invite-btn {
  display: flex;
  align-items: center;
  justify-content: center;
}
.body-wrapper {
  display: block;
  height: calc(100% - 10rem);
  padding: 10px;
  .details-wrapper {
    display: flex;
  }
  .edit-community {
    .hide-desc {
      visibility: hidden;
    }
    .map-desc {
      text-align: end;
    }
  }
  .community-map {
    flex: 1;
    padding-left: 16px;
    position: relative;
    .map__marker {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -60px;
      margin-left: -30px;
    }
  }

  .community-details {
    flex: 1;
    width: 50%;
    margin-top: 0 !important;
    .image-wrapper-edit {
      .image-edit {
        opacity: 1 !important;
        cursor: pointer;
      }
    }
    .community-image {
      position: relative;
      display: inline-block;
      img {
        max-height: 300px;
        width: 100%;
        border-radius: 4px;
        object-fit: cover;
      }
      .image-edit {
        border-radius: 8px;
        text-align: center;
        top: 0;
        opacity: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: absolute;
        transition: opacity 0.3s;

        i {
          font-size: 20px;
          color: white;
          position: relative;
          top: 50%;
        }
        i:hover {
          background-color: transparent;
        }
      }
    }
    .edit-btn {
      margin: 8px 0;
    }
  }

  .editable {
    border-color: black;
    display: flex;
    padding: 8px;
    width: 100%;
    margin: auto;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
      0 1px 2px rgba(0, 0, 0, 0.24);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    border-radius: 4px;
    .single-info {
      // width: 260px;
      flex: 1;
      .edit-btn {
        color: white;
      }
      .label {
        font-size: 1.2rem;
        font-weight: 600;
      }
      .value {
        margin-top: -6px;
        display: flex;
        justify-content: space-between;
        span {
          width: 190px;
          display: flex;
          align-items: center;
          white-space: nowrap;
        }
      }
      &.action {
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }
  }
}

.table-wrapper {
  margin-top: 20px;
  position: relative;
}

.error {
  color: red;
  position: absolute;
  width: 100%;
  margin-top: 8px !important;
}

.invite-members {
  max-height: 100%;
  width: 100%;
  overflow-y: auto;
  align-content: center;
  text-align: center;
  display: flex;
  flex-direction: column;
  position: relative;

  .input-wrapper {
    width: 40%;
    padding: 2px;
    margin: 0 auto;
    display: inline-flex;
  }

  .input-wrapper:not(:last-child) {
    margin-bottom: 1rem;
  }
}

.btn--send {
  min-width: 290px;
}

#pozovi-nove-članove {
  text-align: center;
}

.icon {
  position: relative;
  border-radius: 100%;
  padding: 0;
  padding-left: 5px;
  margin: auto 0;
}

.icon:hover {
  background-color: white;
  color: red;
}

.plus-wrapper {
  text-align: center;
  padding: 1.5rem 0;
  font-size: 1.4rem;

  i:hover {
    color: var(--primary-color);
  }
}

.top-left-wrapper {
  position: absolute;
  z-index: 10;
  &.apartments {
    margin-top: -12px;
  }
  &.members {
    padding-top: 24px;
  }
}

.numMembers {
  // position: absolute;
  // margin-bottom: -46px !important;
}

h1,
h2 {
  text-align: center;
}

h1 {
  padding-top: 25px;
  position: relative;
}

h2 {
  color: #636363;
  padding-bottom: 20px;
}

i {
  padding: 5px;
  position: absolute;
  left: 0;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.25s;
}

i:hover {
  background-color: rgba(176, 178, 178, 0.5);
}

.spinner {
  padding-top: 10%;
}
</style>
